import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBranchLocation,
  saveBranchLocation,
  deleteBranchLocation,
} from "./branchLocationThunk";

const initialState = {
  location: null,
  loading: false,
  error: null,
};

const branchLocationSlice = createSlice({
  name: "branchLocation",
  initialState,
  reducers: {
    resetBranchLocation: () => initialState,
    setBranchLocation: (state, action) => {
      state.location = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBranchLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.location = action.payload || null;
      })
      .addCase(fetchBranchLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch branch location";
      })
      .addCase(saveBranchLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveBranchLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.location = action.payload || state.location;
      })
      .addCase(saveBranchLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to save branch location";
      })
      .addCase(deleteBranchLocation.fulfilled, (state) => {
        state.location = null;
      });
  },
});

export const { resetBranchLocation, setBranchLocation } = branchLocationSlice.actions;
export default branchLocationSlice.reducer;
